function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "transparent",
  d: "M.5 14c0-7.73198688 6.26801312-14 14-14 7.7319869 0 14 6.26801312 14 14 0 7.7319869-6.2680131 14-14 14-7.73198688 0-14-6.2680131-14-14z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M10.9511688 10.9031464v8.0966386H8.16476687v-8.0966386h2.78640193zm.1835194-2.50461703c0 .77742649-.6050911 1.39949666-1.57666473 1.39949666h-.01780662C8.60475728 9.79802603 8 9.17595586 8 8.39852937 8 7.60465908 8.623176 7 9.57638654 7c.95321056 0 1.54021686.60465908 1.55830166 1.39852937zM21 14.3574199l-.0001113 4.6423651h-2.7862906v-4.3317062c0-1.0880317-.4032086-1.8304748-1.4118979-1.8304748-.7698024 0-1.2283228.500515-1.4297045.9839413-.0736749.1732511-.0917598.4146418-.0917598.6566237V19h-2.7867357s.0367261-7.336892 0-8.0966387h2.7867357v1.146821c.3698212-.5512974 1.0321718-1.3371607 2.5115679-1.3371607C19.6253847 10.7130216 21 11.8704827 21 14.3574199z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "29px",
    height: "28px",
    viewBox: "0 0 29 28"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-linkedin.6b011cf9.svg";
export { SvgComponent as ReactComponent };